import { Translate } from '../../i18n';
import { m } from '../../mithril';
import type { MithrilVNode } from '../../mithril';
import { addStyles } from '../theme';
import { BearingInput } from './bearing.input';
import { DistanceInput } from './distance.input';
import type { VectorInputState } from './vector.input.state';
import { CSS, Style } from './vector.input.style';

addStyles(Style);

export const VectorInput = {
	view(state: VectorInputState): MithrilVNode {
		return m('div', { className: CSS.container }, [
			m('div', { className: CSS.inputs }, [
				m('div', { className: CSS.leftInput }, DistanceInput.view(state.distance)),
				m('div', { className: CSS.rightInput }, BearingInput.view(state.bearing)),
			]),
			state.hasError() ? m('span', { className: CSS.MDL.error + ' ' + CSS.error }, Translate(state.error)) : null,
		]);
	},
};
